// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: 'Leading space not allowed.',
  trailingSpaceNotAllowed: 'Trailing space not allowed.',
  mustbeAtleastCharacters: '{{label}} must be atleast {{minNumber}} characters',
  cannotExceedCharacters: '{{label}} cannot exceed {{maxNumber}} characters',
  numberMustbeAtleast: '{{label}} must be atleast value {{minNumber}}',
  numberCannotExceed: '{{label}} cannot exceed {{maxNumber}}',
  isRequired: '{{label}} is required',
  emptySpaceNotContain: 'This field cannot contain space',
  noData: 'No data available.',
  404: '404',
  register: 'Register',
  login: 'Login',
  comingSoon: 'Coming Soon',
  submit: 'Submit',
  email: 'Email',
  termsConditions: 'Terms & Conditions',
  password: 'Password',
  eighteenPlus: 'I’m over 18 years of age and I agree to the Terms of Service',
  signUp: 'SignUp',
  createNewAccount: 'Create New Account',
  fullName: 'Full Name',
  referralCode: 'Referral Code',
  confirmPassword: 'Confirm Password',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Have an account? ',
  pageNotFound: 'We can’t find the page you are looking for!',
  error: 'Error',
  somethingWentWrong: 'Something went wrong!',
  personalDetails: 'Personal Details',
  firstName: 'First Name',
  lastName: 'Last Name',
  dateOfBirth: 'Date of birth',
  phoneNumber: 'Phone Number',
  change: 'Change',
  saveChanges: 'Save Change',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  myProfile: 'My Profile',
  leaveTable: 'Leave the table',
  transactions: 'Transactions',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  referral: 'Referral',
  changePassword: 'Change Password',
  logout: 'Logout',
  currency: 'Currency.',
  view: 'View',
  ok: 'Ok',
  cancel: 'Cancel',
  userName: 'Username',
  passwordRegexMatch: 'Password must contain one uppercase, one number and one special case character',
  invalidEmailFormat: 'Invalid email format',
  noRecordsFound: 'No Records Found',
  noTablesFound: 'No tables found',
  backToLobby: 'Back to lobby',
  noPlacedBet: 'No placed Bet',
  walletBalance: 'Wallet Balance',
  join: 'Join',
  full: 'Full',
  empty: 'Empty',
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Login successfully.',
  logoutSuccessfully: 'Logout successfully.',
  passwordUpdateSuccessfully: 'Password updated successfully.',
  updatePlayerStatusSuccessfully: 'Player status updated successfully.',
  resetPasswordSuccessfully: 'Password reset successfully.',
  signupSuccessfully: 'Signup successfully.',
  betPlacedSuccessfully: 'Bet Placed  successfully.',
  betCancelledSuccessfully: 'Bet cancelled  successfully.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Your session has timed out',
  LoggedInElsewhereError: 'Your account was signed in on another device. Please log in again.',
  PleaseRotateYourDevice: 'Please rotate your phone',
  PleaseRotateYourDeviceHint: 'This game works best in landscape mode.',
  LoginFailedError: 'Login Failed',
  InvalidCredentialsError: 'Invalid Credentials',
  InvalidTokenError: ' Token is not valid',
  InvalidSessionError: ' Session expired',
  CreateUserError: 'User cannot be created',
  DataMismatchError: 'Data does not match',
  UserNotFoundError: 'User not found',
  DuplicateEmailError: 'Email already exists',
  RequestInputValidationError: 'Please check the request data',
  ResponseInputValidationError: 'Response validation failed please refer to the JSON schema of the response',
  SocketRequestInputValidationError: 'Please check the request data for socket communication',
  SocketResponseValidationError: 'Response validation of socket communication failed, please refer to the JSON schema of the response',
  InternalServerError: 'Internal Server Error',
  InvalidSocketArgumentError: 'Please provide proper arguments: eventName, [payloadObject], and [callback]',
  InvalidCredentials: 'Credentials do not match',
  InvalidToken: 'Either access token was not passed or it has expired',
  InvalidSession: 'User session is not valid, please re-login',
  InvalidAccess: 'Permission denied',
  NonOperationalError: 'An error occurred on the server',
  UserNotExists: 'User does not exist',
  InvalidAction: 'Invalid action',
  SessionAlreadyStarted: 'Session already started',
  SessionNotStarted: 'Session not started',
  EmailNotVerified: 'Email not verified',
  InvalidGameTypeError: 'No settings found for the provided game type',
  InvalidGameRoundError: 'No game found for the provided game details',
  NoRoundRunningError: 'No round is running at the moment',
  NoPlacedBetFoundError: 'No placed bet found',
  NoWalletFoundError: 'Wallet not found with the specified data',
  NotEnoughBalanceError: 'Balance is not sufficient to perform the process',
  AutoRateIsInvalidError: 'Auto Rate is not within the valid limit',
  BetAmountIsNotInLimitError: 'Bet Amount is not within the valid limits',
  EmailNotFound: 'Email not found',
  UserNotAbove18YearsError: 'User is not above 18 years old',
  InvalidBlockchainAddress: 'Invalid Blockchain Address',
  AddressMismatch: 'Given Address and Recovered Address Mismatch',
  NonceLifetimeExpired: 'Nonce Lifetime Expired',
  SomethingWentWrong: 'Something Went Wrong',
  AccountNotActive: 'Account is not active',
  LoginTokenRequire: 'OTP (One-Time Password) is required',
  UserAlreadyExists: 'User already exists',
  InvalidVerificationToken: 'Invalid verification token',
  UserNotActive: 'User is blocked, please contact admin',
  FileUploadFailed: 'Image upload failed',
  EmailAlreadyVerified: 'Email is already verified',
  InvalidReferralCode: 'Invalid Referral Code',
  InvalidAffiliateCode: 'Invalid Affiliate Code',
  RecordNotFound: 'Record Not Found',
  WithdrawalRequestAlreadyPending: 'Withdrawal request is already pending',
  WalletDoesNotBelongToUser: 'Wallet does not belong to this user',
  BetAlreadyInProgress: 'Bet is already in progress',
  ServerSeedNotFoundErrorType: 'Server seed not found, please log in again',
  InvalidMineCountErrorType: 'Mine count must be in the range of 1 to 24',
  InvalidTileErrorType: 'Tile must be in the range of 1 to 25',
  MineTileAlreadyOpenedErrorType: 'Select another tile',
  NoOpenedTileFoundErrorType: 'No opened tile found for this bet',
  MineGamePreviousRoundNotCompletedErrorType: 'Mine Game previous round not completed',
  BlackJackPreviousRoundNotCompletedErrorType: 'Black Jack Game previous round not completed',
  BlackJackGameDoubleBetErrorType: 'Black Jack Game unable to double the bet',
  BlackJackGameSplitBetErrorType: 'Black Jack Game unable to split the bet',
  BlackJackGameSplitHitErrorType: 'Black Jack Game unable to draw a card',
  FavoriteGameExistsErrorType: 'Favorite Game already exists',
  FavoriteGameNotFoundErrorType: 'Favorite Game not found',
  TransactionAlreadyPendingErrorType: 'Transaction is already pending',
  UserHasNoActiveBonusErrorType: 'User has no active bonus',
  BonusExpiredErrorType: 'Bonus has expired',
  UserHasAlreadyActivatedBonusWageringErrorType: 'User has already activated bonus wagering',
  InvalidRoundHashErrorType: 'Wrong Round Hash',
  InvalidSignatureErrorType: 'Wrong Signature',
  UserHasNoBonusAmountToClaimErrorType: 'User has no bonus amount to claim',
  BonusNotExistsErrorType: 'Bonus not found',
  PokerGameJoinTableErrorType: 'Error in joining table',
  PokerGameLeaveTableErrorType: 'Error in leaving tournament',
  PokerGameRoundNotRunningErrorType: 'Round is not running',
  PokerGamePlayerNotSeatedErrorType: 'Players are not seated',
  PokerGameRoundHandDetailsErrorType: 'Round hand details not found',
  PokerGameBetRangeErrorType: 'Placed bet does not satisfy the minimum bet condition',
  PokerGamePlaceBetErrorType: 'Error in placing bet',
  PokerGamePlayerAlreadySeatedErrorType: 'You are already seated at another table. Leave that table before joining a new one.',
  BlockedTransactionErrorType: 'Transaction block error',
  PokerGameBuyInRangeErrorType: 'Buy-in range does not satisfy the minimum and maximum buy-in range condition',
  PokerGameSeatNotAvailableFoundErrorType: 'Seat is not available',
  PokerGameTakeSeatErrorType: 'Error in taking a seat',
  PokerGameGetTablesErrorType: 'Error in fetching poker game tables',
  PokerGameSeatNotFoundErrorType: 'Error in fetching poker game tables seat',
  PokerGameTableNotFoundErrorType: 'Error in fetching poker game tables',
  PokerGameCalculateSidePotErrorType: 'Error in calculating side pot',
  PokerGameHandleBetErrorType: 'Error in handling bet',
  PokerGameHandleCallErrorType: 'Error in handling call',
  PokerGameHandleCheckErrorType: 'Error in handling check',
  PokerGameHandleFoldErrorType: 'Error in handling fold',
  PokerGameHandleRaiseErrorType: 'Error in handling raise',
  PokerGameStackRaiseAmountCannotBeLessThenZeroErrorType: 'Error in handling raise when raise amount is less than 0',
  PokerGameStackAmountLessThenRaiseAmountErrorType: 'Error in handling raise when stack amount is less than raise amount'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  dealMeIn: 'DEAL ME IN',
  betAmount: 'Bet Amount',
  betHistory: 'Bet History',
  provablyFair: 'Provably Fair',
  minimumBet: 'Minimum bet',
  maximumBet: 'Maximum bet',
  selectYourBetAmount: 'Select your bet amount',
  buyInAmount: 'BuyIn Amount',
  selectYourBuyInAmountFromGivenRange: 'Select your BuyIn Amount from given range',
  profitOnWin: 'Profit on Win',
  profitOnSingleWin: 'Profit on Single Win',
  noOfBets: 'Number of bets',
  auto: 'Auto',
  half: '½',
  double: '2x',
  start: 'Start',
  cancel: 'Cancel',
  prediction: 'Prediction',
  luckyNumber: 'Lucky Number',
  multiplier: 'Multiplier',
  chanceToWin: 'Chance to win',
  betBtn: 'Place Bet',
  bets: 'Bets',
  depositBtn: 'Deposit',
  rollOver: 'Roll Over',
  rollUnder: 'Roll Under',
  invalidBetAmount: 'Invalid bet amount',
  maxBetAmountLimit: 'Max bet amount {{value}} limit exceeded',
  minBetAmountLimit: 'Min bet amount is {{value}}.',
  noBalance: 'Bet amount is greater than wallet balance',
  noAutoCashout: 'Auto rate is required.',
  autoRateLimitWarning: 'Auto rate should be greater than {{value}}',
  potentialWin: 'Potential Win',
  gameMode: 'Game mode',
  changeSeeds: 'Change Seeds',
  betAmt: 'Total Bet Amount',
  chipValue: 'Chip Value: 1 chip = 0.01',
  undo: 'Undo',
  clear: 'Clear',
  changeSeedModal: {
    heading: 'Change Seeds',
    description: 'The server seed and client seed are the two ingredients which generate the result of this game. Both change after each bet. Server seed hash is SHA256 hash of next round server seed.',
    clientSeed: {
      label: 'Client Seed'
    },
    serverSeedHash: {
      label: 'Server Seed Hash'
    },
    loading: 'Loading ...',
    alphanumeric: {
      message: 'Enter a valid client seed alphanumeric string'
    },
    editClientSeed: {
      label: 'Edit Client Seed'
    },
    save: {
      label: 'Save'
    }
  },
  betCancelledSuccessfully: 'Bet cancelled  successfully',
  maxAmountWarning: 'Bet amount cannot be greater than ',
  minAmountWarning: 'Bet amount cannot be less than ',
  noAmountWarning: 'Please, check your bet amount',
  inSufficientBalanceWarning: 'Not enough balance.',
  placeBetWarning: 'Please login to place bet.',
  autoRateWarning: 'Auto rate should be greater than or equal to',
  autoRateWarningMaxOdds: 'Auto rate should be less than or equal to',
  limit: 'limit exceeded.',
  notAchieved: 'not achieved.',
  maxBetAmount: 'Max bet amount',
  minBetAmount: 'Min bet amount',
  messages: {
    maxBetAmount: 'Max bet amount',
    limit: 'limit exceeded.',
    minBetAmount: 'Min bet amount',
    notAchieved: 'not achieved.',
    zeroError: 'Bet number should be more than 0',
    inSufficientBalanceWarning: 'Not enough balance.',
    noBalance: 'Not enough balance.',
    copyNotSupported: 'Copy not supported.',
    copied: 'Text copied.'
  },
  winCount: 'Win Count',
  lossCount: 'Loss Count',
  placeBetFailed: 'Place Bet Failed',
  youAlreadyHaveBetPlaced: 'You already have a Bet Placed.',
  cashOutFailed: 'Cash Out Failed',
  enterValidBetsCount: 'Enter the valid Number of Bets',
  stoppingBet: 'Stopping Autobet',
  segments: 'Segments',
  playWheel: 'Play Wheel',
  placeBet: 'Place Bet',
  space: 'Space',
  doubleBetAmt: 'Double Bet Amount',
  w: 'W',
  halveBetAmt: 'Halve Bet Amount',
  s: 'S',
  incRollOverUnder: 'Increase RollOver / Roll Under Rate',
  a: 'A',
  decRollOverUnder: 'Decrease RollOver / Roll Under Rate',
  d: 'D',
  hotkeyNote: "When the hotkeys are enabled, they will remain on for all games until disabled. Despite some games sharing similar key binds, it's always advised to confirm what key interactions are set for each game.",
  max: 'Max',
  stopOnProfit: 'Stop On Profit',
  stopOnLoss: 'Stop On Loss',
  configureAuto: 'Configure Auto',
  apply: 'Apply',
  winChance: 'Win Chance',
  provableFair: 'Provable Fair',
  placedByUserId: 'Placed By User ID',
  resetAll: 'Reset All',
  strategyApplied: 'Strategy applied',
  strategyReset: 'Strategy reset',
  startAutoBet: 'Start Autobet',
  stopAutoBet: 'Stop Autobet',

  // EXA GAMING TRANSLATIONS
  STATS: 'Stats',
  ALL: 'All',
  TOP: 'Top',
  HISTORY: 'History',
  BET: 'Bet',
  NO_PLACED_BETS: 'No placed bet.',
  NO_DATA: 'No data available.',
  BET_HISTORY: 'Bet History',
  LOAD_MORE: 'Load More',
  AUTO_BET: 'Auto Bet',
  BET_TYPE: 'Bet Type',
  BET_AMOUNT: 'Bet Amount',
  AUTO_CASHOUT: 'Auto Cashout',
  CASHOUT_AT: 'Cashout At',
  ADD: 'Add',
  MULTIPLY: 'Multiply',
  CANCEL: 'Cancel',
  CASH_OUT: 'CASH OUT',
  CANCEL_AUTO_BET: 'Cancel Autobet',
  START_AUTOBET: 'Start Autobet',
  CANCEL_AUTOBET: 'Cancel Autobet',
  NOT_BALANCE: 'Not enough balance.',
  MAX_BET_ERR: 'Max bet amount',
  LIMIT_ERR: 'limit exceeded.',
  MIN_BET_ERR: 'Min bet amount',
  NOT_ARCHIEVED: 'not achieved.',
  MAX_LIMIT_ERR: 'Max bet limit error',
  MIN_LIMIT_ERR: 'Min bet limit error',
  AUTO_RATE_ERR: 'Auto rate should be greater than or equal to',
  AUTO_RATE_WARNING: 'Auto rate should be less than or equal to',
  MIN_AUTO_ERR: 'Min AutoRate Error',
  MAX_AUTO_ERR: 'Max AutoRate Error',
  NO_AUTO_CASHOUT: 'Please provide Auto Cashout amount',
  NO_CASHOUT: 'No Auto Cashout',
  CHAT: 'Chat',
  SETTINGS: 'Settings',
  LANGUAGE: 'Language',
  VOLUME: 'Volume',
  MUTE: 'Mute',
  HOW_TO_PLAY: 'HOW TO PLAY',
  DISABLE: 'Disable',
  CHAT_DISABLED: 'Chat Disabled',
  TURN_CHAT: 'Turn the Chat on',
  TO_DISCUSS: 'to discuss.',
  SEND_MESSAGE: 'Send Message',
  INVALID_INPUT_MESSAGE: 'Invalid input message.',
  TEXT_COPY: 'Text Copied!',
  COPIED: 'Copied',
  INFO: 'Infos',
  MULTIPLIER: 'Multiplier',
  ROUND_ID: 'Round Id',
  ROUND_HASH: 'Round Hash',
  ROUND_SIGNATURE: 'Round Signature',
  GAME_LIMIT: 'Game Limits',
  GOLD_COIN: 'Gold Coins',
  MINIMUM_BET: 'Minimum Bet',
  MAXIMUM_BET: 'Maximum Bet',
  MAX_WIN: 'Maximum win for one bet',
  SWEEPSTAKE_COIN: 'Sweepstakes Coins',
  HOW_PLAY: 'How To Play',
  HOW_PLAY_AZTECMAN: 'AztecMan is a new game by GS-Custom! You can win many times over with our innovative play for fun crash game! AztecMan is built on a provably fair system. Have Fun!',
  HOW_PLAY_FOLLOW_ARROW: 'Follow The Arrow is a new game by Exa-Gaming! You can win many times over with our innovative play for fun crash game! Follow The Arrow is built on a provably fair system. Have Fun!',
  HOW_PLAY_POWER_THOR: 'Power Of Thor is a new game by Exa-Gaming! You can win many times over with our innovative play for fun crash game! Power Of Thor is built on a provably fair system. Have Fun!',
  HOW_PLAY_DRACARYS: 'Dracarys is a new game by Exa-Gaming! You can win many times over with our innovative play for fun crash game! Dracarys is built on a provably fair system. Have Fun!',
  HOW_PLAY_HAPPY_BIRD: 'Happy Bird is a new game by Exa-Gaming! You can win many times over with our innovative play for fun crash game! Happy Bird is built on a provably fair system. Have Fun!',
  HOW_PLAY_TOP_INFO: '{{gameName}} is a new game by GS-Custom! You can win many times over with our innovative play for fun crash game! {{gameName}} is built on a provably fair system. Have Fun!',
  GAME_DETAIL: 'Game Details',
  HOW_PLAY_ONE: 'The win multiplier starts at 1x and grows more and more as the Character takes off.',
  HOW_PLAY_TWO: 'Your winnings are calculated at the multiplier at which you made a Cash Out, multiplied by your bet.',
  HOW_PLAY_THREE: 'Before the start of each round, our provably fair random number generator generates the multiplier at which the Character will crash. You can get the Round Id, Round Hash, and Round Signature, in the Infos tab',
  BET_CASHOUT: 'Bet & Cashout',
  HOW_PLAY_FOUR: 'You can make multiple bets simultaneously, by using the two different bet panels.',
  HOW_PLAY_FIVE: 'Press the “Cash Out” button to cash out your winnings. Your win is your bet multiplied by the Cash Out multiplier.',
  HOW_PLAY_SIX: 'Your bet is lost, if you didn’t cash out before the character flies away.',
  AUTO_PLAY_CASHOUT: 'Auto Play & Auto Cash Out',
  HOW_PLAY_SEVEN: 'Auto Play is activated by turning on the “Auto Bet” switch on the bet panel.',
  HOW_PLAY_EIGHT: 'Auto Cash Out is available by turning on the “Auto Cashout” switch on the Bet panel. After activation, your bet will be automatically cashed out when it reaches the multiplier entered',
  LIVE_BETS_STATISTIC: 'Live Bets & Statistics',
  HOW_PLAY_NINE: 'On the right side of the game interface (or under the Bet Panel on mobile), is located the Live Bets panel. Here you can see all bets that are being made in the current round.',
  HOW_PLAY_TEN: 'In the “History” panel you can see all of your bets and Cash Out information.',
  HOW_PLAY_ELE: 'In the “Top” panel, game statistics are located. You can browse wins by amount, or Cash Out multiplier, and see the biggest round multipliers.',
  OTHER: 'Other',
  HOW_PLAY_TWE: 'If the internet connection is interrupted when the bet is active, the game will auto cash out with the current multiplier, and the winning amount will be added to your balance.',
  HOW_PLAY_THIRT: 'In the event of a malfunction of the gaming hardware/software, all affected game bets and payouts are rendered void and all affected bets are refunded.',
  NEXT_ROUND: 'Next Round',
  ROUND_HASH_ERR: 'Round Hash is Required',
  SIGNATURE_ERR: 'Signature is Required',
  CHECK_PROVABLY: 'Check Provably Fair',
  PROVABLY_DESCRIPTION: 'This game uses Provably Fair technology to determine game result. This tool gives you ability to change your seed and check fairness of the game.',
  CRASH_RATE: 'Crash Rate',
  SIGNATURE: 'Signature',
  LOADING: 'Loading',
  VERIFY_GAME: 'Verify Game',
  VERIFY_DESCRIPTION: 'You can check fairness of each round from round history.',
  YOU_WIN: 'You win',
  PLAY_AGAIN: 'PLAY AGAIN',
  GENERAL_INFO: 'Infos',
  HISTORY_ROUNDS: 'History of rounds',
  PRIMARY_BET: 'Primary Bet',
  SECONDARY_BET: 'Secondary Bet',
  GENERAL_STATS: 'Stats',
  GENERAL_PLAY: 'Play',
  GENERAL_MESSAGES: 'Messages',
  CHOOSE_VESSEL: 'Choose Your Vessel!',
  GENERAL_DESC: 'Select the Character you Would Like to Take you to the Moon! ',
  ROCKET_FISH: 'Rocket Fish',
  ROCKET_BOY: 'Rocket Boy',
  HAPPY_KITEN: 'Happy Kitten',
  START_PLAYING: 'Start Playing!',
  TempleGold: 'Temple Gold',
  DRACARYS: 'Dracarys',
  FOLLOW_THE_ARROW: 'Follow The Arrow',
  HAPPY_BIRD: 'Happy Bird',
  POWER_OF_THOR: 'Power Of Thor',
  STAR_CATCHER: 'Star Catcher',
  TYPE_HERE: 'Type here',
  WIN: 'Win',
  LOSE: 'Lose',
  PENDING: 'Pending',
  WAITING_FOR_NEXT_ROUND: 'Wait For Next Round',
  LOGIN_SUCCESS: 'Login Successfully',
  GAME_CLOSED_SUCCESS: ' Game Closed Successfully',
  BET_PLACED_SUCCESS: 'Bet Placed Successfully',
  PLAYER_ESCAPED_SUCCESS: 'Player Escaped Successfully',
  BET_CANCEL_SUCCESS: 'Bet Cancel Successfully',
  INTERNAL_SERVER_ERROR: 'Internal Server Error',
  UNAUTHORIZED: 'Unauthorized',
  GAME_NOT_AVAILABLE: '{{gameName}} game is not Available',
  CONTACT_PROVIDER: 'Please Contact operator',
  THIS_GAME: 'This',
  TODO_ROCKET: 'TODO Rocket',
  PAGE_NOT_FOUND: 'Page Not Found',
  SOMETHING_WENT_WRONG: 'Something went wrong!',
  BALANCE: 'Balance',
  HIT: 'Hit',
  STAND: 'Stand',
  SPLIT: 'Split',
  DOUBLE: 'Double',
  INSURANCE: 'Insurance',
  ACCEPT_INSURANCE: 'Accept Insurance',
  NO_INSURANCE: 'No Insurance',
  PLACE_BET: 'Place Bet',
  SPLIT_BET: 'Split Bet',
  FAIRNESS: 'Fairness',
  BET_AMOUNT_ERROR: 'Bet Amount is not in the limits',
  INSUFFICIENT_ERROR: 'Insufficient balance to place a bet',
  INVALID_BET_AMT_ERROR: 'Invalid Bet Amount',
  COPY_ERR: 'Copy not supported.',
  COPPIED: 'Coppied',
  SEEDS: 'Seeds',
  VERIFY: 'Verify',
  BET_CLIENT_SEED: 'Last Bet Client Seed',
  BET_SERVER_SEED: 'Last Bet Server Seed',
  ROTATE_SEED: 'Rotate Seed Pair',
  NEW_SEED: 'New Client Seed',
  CHANGE: 'Change',
  NEXT_SEED: 'Next Server Seed (Hashed)',
  DEALER_CARD: 'Dealer cards',
  USER_CARD: 'User cards',
  DECK_CARD: 'Deck cards',
  CORRECT_INPUT_RESULT: 'Correct inputs are required to verify result',
  GAME: 'Game',
  CLIENT_SEED: 'Client Seed',
  SERVER_SEED: 'Server Seed',
  PLINKO_ROLE_ONE: 'Configured modes via risk and multiplier determine different potential payouts.',
  PLINKO_ROLE_TWO: 'No gravity hacks by rotating device or monitors while playing.',
  OK: 'Ok',
  RULES: 'Rules',
  BLACKJACK: 'Blackjack',
  ID: 'ID {{id}}',
  PLACE_DATE: 'Place by You on Date',
  ROUND_RESULT: 'Round Result',
  PAYOUT: 'Payout',
  PLAY_BLACKJACK: 'Play Blackjack',
  RANK: 'Rank',
  USER: 'User',
  DATE: 'Date',
  CASHOUT_ERROR: 'Cannot cashout with zero opened tiles',
  MINE_BET_ERROR: 'Please provide valid number of bets',
  TILE_ERROR: 'Please select some tiles',
  NO_BALANCE: 'Can not bet more than your balance',
  MAX_BET_AMOUNT_LIMIT: "You've exceeded the max bet limit of {{value}}.",
  MIN_BET_AMOUNT_LIMIT: 'Your bet is below the minimum limit of {{value}}.',
  MIN_BET_AMOUNT_LIMIT_MIN_MAX_INFO: "Your bet amount can't go below min bet amount of {{value}}.",
  MAX_BET_AMOUNT_LIMIT_MIN_MAX_INFO: "Your bet amount can't exceed max bet amount of {{value}}.",
  NOT_ACHIEVED: 'Not Achieved',
  MAX_BET_AMOUNT: 'Max Bet Amount',
  MIN_BET_AMOUNT: 'Min Bet Amount',
  LIMIT: 'Limit',
  ROLLS_LIMIT_MSG: 'Rolls Limit Message',
  MAX_ROLLS_LIMIT: "You've exceeded the max number of bets limit of {{value}}.",
  TILE_OPEN: 'All tiles opened',
  MANUAL: 'Manual',
  AUTO: 'Auto',
  MAX: 'Max',
  MINES: 'Mines',
  STARS_LEFT: 'Stars left',
  TOTAL_PROFIT: 'Total profit',
  PICK_TILE: 'Pick random tile',
  CASHOUT: 'Cashout',
  NUM_OF_BETS: 'Number of Bets',
  ON_WIN: 'On Win (%)',
  ON_LOSS: 'On Loss (%)',
  STOP_PROFIT: 'Stop on Profit',
  STOP_LOSS: 'Stop on Loss',
  CONFIGURE_AUTO: 'Configure Auto',
  STRATEGY_APPLY: 'Strategy applied.',
  DATA_ERROR: 'Entered data is invalid',
  INCREASE_BY: 'Increase by',
  RESET: 'Reset',
  RESET_ALL: 'Reset All',
  APPLY: 'Apply',
  TILE_ERR: 'Cannot select more tiles',
  YOU: 'You',
  WON: 'WON!',
  LOST: 'LOST!',
  BET_TOOLTIP: 'Your bet amount per ball is {{maxBetAmt}}.',
  MAX_PAYOUT: 'Max Payout:',
  YOUR_BET: 'Your Bet',
  MIN: 'Min',
  TOTAL_BET: 'Total Bet Amount:',
  NUM_BALL: 'Number of Balls',
  ROWS: 'Rows',
  NUM_BET: 'Numbers of Bets',
  STOP_AUTOBET: 'Stop Autobet',
  TURBO: 'Turbo',
  LIVE_STATS: 'Live Stats',
  PROFIT: 'Profit / Loss',
  WINS: 'No. of Wins',
  WAGERED: 'Wagered',
  LOSS: 'No. of Losses',
  HOTKEY: 'Hotkeys',
  RISKS: 'Risks',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  PLINKO_NUM_ERR: 'Cannot change number of lines when game is running!',
  BET_AMOUNT_ERR: 'Please provide Bet amount',
  BET_AMOUNT_PROVIDE_ERROR: 'Please provide valid Bet amount',
  SPACE: 'Space',
  DOUBLE_BET: 'Double Bet Amount',
  HALVE_BET: 'Halve Bet Amount',
  DECREASE_ROW: 'Decrease Number of Rows',
  INCREASE_ROW: 'Increase Number of Rows',
  HOTKEY_ENABLED: 'Hotkeys Enabled',
  HOTKEY_DESCRIPTION: 'When the hotkeys are enabled, they will remain on for all games until disabled. Despite some games sharing similar key binds, it’s always advised to confirm what key interactions are set for each game.',
  ASSET_LOAD_ERROR: 'Game Assets Not Loaded! Please reload the website',
  ROULETTE: 'Roulette',
  CHANGE_SEED: 'Change Seed',
  HALF: 'Half',
  BET_NUMBER: 'Bet number',
  CHIP: 'Chips',
  START: 'Start',
  YOU_WON_AMT: 'You Won {{currency}}{{amount}}',
  YOU_WON_AMT_AND_MULTI: 'You Won {{currency}}{{amount}} ({{multiplier}}x)',
  YOU_LOST: 'You Lost!',
  UNDO: 'Undo',
  CLEAR: 'Clear',
  YOU_WON: 'YOU WON',
  SEED_HEADING: 'Fairness',
  SEED_CLIENT_LABEL: 'Client Seed',
  SEED_HASH_LABEL: 'Server Seed',
  SEED_LOADING: 'loading...',
  SEED_ALPHA_MESSAGE: 'Seeders should be alphanumeric.',
  SEED_SAVE_LABEL: 'Save',
  SEED_EDIT_LABEL: 'Edit',
  SEED_DESCRIPTION: 'Seeds',
  GENERATE_SEED: 'Generate New Seeds',
  COLUMN_BET_SELECTION: 'You can only select {{maxValHoldCount}} Column bets.',
  DOZEN_BET_SELECTION: 'You can only select {{maxValHoldCount}} Dozen bets.',
  ODD_EVEN_BET_SELECTION: 'You can only select {{maxValHoldCount}} Even or Odd bet.',
  COLOR_BET_SELECTION: 'You can only select {{maxValHoldCount}} Red or Black color bet.',
  LOW_HI_BET_SELECTION: 'You can only select {{maxValHoldCount}} Low-High bet',
  ROULETTE_MAX_BET_LIMIT: "Max bet Amount is {{maxAmt}}. You can't select more than the max bet amount.",
  LAST_CRASH_RATE: 'Last Bet Crash Rate',
  MINE_SPACE: 'Space',
  MINE_SPACE_RULE: 'Place Bet or Cashout or Cancel Bet ( Auto Bet )',
  MINE_W: 'W',
  MINE_W_RULE: 'Double Bet Amount',
  MINE_S: 'S',
  MINE_S_RULE: 'Halve Bet Amount',
  MINE_A: 'A',
  MINE_A_RULE: 'Remove a Mine',
  MINE_D: 'D',
  MINE_D_RULE: 'Add a Mine',
  MINE_Q: 'Q',
  MINE_Q_RULE: 'Pick a Random Tile',
  RESULT_CORRECT_INPUT: 'Correct inputs are required to verify result',
  WIN_AMOUNT: 'Win Amount',
  DATE_TIME: 'Date / Time'
}

/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys
}
